import Raven from 'raven-js';
import { UserContext } from './UtilsTypes/types';
// Service to send errors to Sentry
const ErrorService = {
  capture: (title: string, extra?: unknown) => {
    if (typeof document === 'undefined' || !document?.location) return;
    Raven.captureException(new Error(title), { extra });
  },
  setUserContext: (context: UserContext = {}) => {
    if (typeof document === 'undefined' || !document?.location) return;
    Raven.setUserContext(context);
  },
  lastEventId: () => {
    if (typeof document === 'undefined' || !document?.location) return null;
    return Raven.lastEventId();
  },
};

export default ErrorService;
